<template lang="pug">
v-tooltip(:disabled="!disabled" top)
  template(v-slot:activator="{ on }")
    div(v-on="on")
      v-btn(v-bind="$attrs", v-on="$listeners", text, color=" textColor" :disabled="disabled")
        v-icon(left, color="textColor", :size="22") {{ replyIcon }}
        span(:style="labelStyles") Kommentieren
  | Nur Gruppenmitglieder können kommentieren.
</template>

<script lang="ts">
import Vue from "vue"
import THEME from "../../constants/theme"
import { mdiReplyOutline } from "@mdi/js"
export default Vue.extend({
  name: "CommentButton",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelStyles: THEME.typography.button,
      replyIcon: mdiReplyOutline,
    }
  },
})
</script>
